export enum IntervalEnum {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}

export type Interval = { unit: IntervalEnum; count: number };

export type PaginationMeta = {
  total: number;
  pages: number;
  page: number;
  size: number;
};
